var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MethodType } from "@michelin/central-provider/dist/helpers/createAPICall";
import { FailedToFetchError } from "../errors/FailedToFetchError";
import { createQueryParams } from "./createQueryParams";
import get from 'lodash/get';
import { createObjFromPath } from "./strings";
export const getChangeHistory = (getChangeHistoryParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { api, authResultToken, except, queryParams, } = getChangeHistoryParams;
    const headers = {
        'Authorization': `Bearer ${authResultToken}`
    };
    const method = MethodType.GET;
    const params = createQueryParams(queryParams);
    const responseData = yield fetch(`${api}?${params}`, {
        cache: 'no-cache',
        headers,
        method,
    });
    if (!responseData.ok) {
        throw new FailedToFetchError({
            url: api,
            queryParams,
            response: responseData,
            headers,
        });
    }
    let result = (yield responseData.json()) || [];
    if (result && result.data && result.data.length) {
        result.data.forEach((r) => {
            r.changes.forEach((change, index) => {
                const CHANGE_BEFORE = get(r.before, change, null);
                const CHANGE_AFTER = get(r.after, change, null);
                try {
                    r.origin = createObjFromPath(r.origin || {}, change, CHANGE_BEFORE, 'origin');
                    r.diff = createObjFromPath(r.diff || {}, change, CHANGE_AFTER);
                }
                catch (e) {
                    console.log("ERROR", e, "CHANGE", change, "BEFORE", CHANGE_BEFORE, "AFTER", CHANGE_AFTER);
                }
                if (except) {
                    delete r.origin[except];
                    delete r.diff[except];
                }
            });
        });
    }
    return result;
});
//# sourceMappingURL=getChangeHistory.js.map